import api from "./AxiosInterceptor";
import EndpointService from "./EndpointService";

export const getProviderRequestsService = async (payload) => {
  const url = EndpointService("getOverrideEligibilityRequests");
  const response = await api.post(url, payload);
  return response;
};
